import { render, staticRenderFns } from "./ArticleOverview.vue?vue&type=template&id=88f41850&"
import script from "./ArticleOverview.vue?vue&type=script&lang=js&"
export * from "./ArticleOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports